export default "__VITE_ASSET__5dfd21e2__"